import * as __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__ from "../../variants/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__ from "../../variants/tv.js";
const sizeVariants = {
    16: 'w-[16px] h-[16px] text-icon-16',
    18: 'w-[18px] h-[18px] text-icon-18',
    20: 'w-[20px] h-[20px] text-icon-20',
    24: 'w-[24px] h-[24px] text-icon-24',
    28: 'w-[28px] h-[28px] text-icon-28',
    32: 'w-[32px] h-[32px] text-icon-32',
    36: 'w-[36px] h-[36px] text-icon-36',
    40: 'w-[40px] h-[40px] text-icon-40',
    48: 'w-[48px] h-[48px] text-icon-48',
    64: 'w-[64px] h-[64px] text-icon-64',
    80: 'w-[80px] h-[80px] text-icon-80',
    96: 'w-[96px] h-[96px] text-icon-96'
};
const iconSizes = Object.keys(sizeVariants);
const cdnIconVariants = (0, __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__.tv)({
    extend: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.foregroundPaletteVariants,
    base: 'material-symbols-icon select-none antialiased',
    variants: {
        size: sizeVariants
    },
    defaultVariants: {
        size: '20'
    }
});
export { cdnIconVariants, iconSizes, sizeVariants };
